/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceSearchVM { 
    lastScanDate?: string | null;
    lastestSyncDate?: string | null;
    id?: number | null;
    deviceUuid?: string | null;
    deviceName?: string | null;
    generatedName?: string | null;
    isJoinedToSchool?: boolean | null;
    isDelivered?: boolean | null;
    status?: string | null;
    deviceType?: string | null;
    name?: string | null;
}

